import type * as models from 'pkg/api/models';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum UserFieldType {
	ShortText = 'string',
	Number = 'number',
	Choice = 'choice',
	MultiChoice = 'multi_choice',
	Date = 'date',
	Email = 'email',
	Phone = 'phone',
	LongText = 'long_text',
	Attachment = 'attachment',
	Reserved = 'reserved',
	Slider = 'slider',
}

export enum ReservedUserField {
	FirstName = 'firstName',
	LastName = 'lastName',
	BirthDate = 'birthDate',
	Email = 'email',
	Sex = 'sex',
	PhoneNumber = 'phoneNumber',
	City = 'city',
	Country = 'country',
	PostalCode = 'postalCode',
	CompanyName = 'companyName',
	Address = 'address',
	Nationality = 'nationality',
	Region = 'region',
	LokSwedishPersonalId = 'lokSwedishPersonalId',
}

export interface UserFieldPayload {
	key?: string;
	required?: boolean;
	visibility?: Visibility[];
	type?: UserFieldType;
	label?: string;
	description?: string;
	values?: userFieldValue[];
	sortOrder?: number;
	active?: boolean;
	groupId: number;
}

interface userFieldValue extends Dateable {
	userId: number;
	userFieldId: number;
	type: UserFieldType;
	value: string;
}

export interface UserFieldOption {
	label: string;
	value: string;
}

export enum Visibility {
	ContactCard = 'contactCard',
	Profile = 'profile',
}

export interface UserField extends Record, Dateable {
	id?: number;
	groupId?: number;
	key: string;
	type: UserFieldType;
	attachment?: models.attachment.Attachment;
	attachmentType?: models.attachment.AttachmentType;
	attachmentId?: number;
	label: string;
	description?: string;
	values?: UserFieldOption[];
	required?: boolean;
	sortOrder?: number;
	visibility?: Visibility[];
	active?: boolean;
	options?: UserFieldOption[];
	userFieldCategoryId?: number;
	displayAsDropdown?: boolean;
}
